export default function disableDummyLinks() {
  const dummyLinks = document.querySelectorAll('[href="#"], [href=""');
  dummyLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
    });
  });
}
